import { render, staticRenderFns } from "./AdminMonthlyCompleteReports.vue?vue&type=template&id=fbffae16&scoped=true&"
import script from "./AdminMonthlyCompleteReports.vue?vue&type=script&lang=js&"
export * from "./AdminMonthlyCompleteReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbffae16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
